"use strict";

var _regeneratorRuntime = require("@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rinkebyCustomSchema = {
  version: 1,
  deploymentBlock: 0,
  name: 'RinkebyCustom',
  description: 'Rinkeby Custom (manual ABI specification)',
  thumbnail: 'https://d30y9cdsu7xlg0.cloudfront.net/png/45447-200.png',
  website: 'https://github.com/projectwyvern/wyvern-schemas',
  fields: [{
    name: 'Name',
    type: 'string',
    description: 'Name of Asset'
  }, {
    name: 'Description',
    type: 'string',
    description: 'Description of Asset'
  }, {
    name: 'Thumbnail',
    type: 'string',
    description: 'URL of asset thumbnail image'
  }, {
    name: 'URL',
    type: 'string',
    description: 'URL of asset'
  }, {
    name: 'Transfer',
    type: 'abi',
    description: 'ABI of transfer function'
  }],
  assetFromFields: function assetFromFields(fields) {
    return {
      name: fields.Name,
      description: fields.Description,
      thumbnail: fields.Thumbnail,
      url: fields.URL,
      transfer: fields.Transfer
    };
  },
  formatter: function formatter(asset) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                thumbnail: asset.thumbnail,
                title: asset.name,
                description: asset.description,
                url: asset.url,
                properties: []
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  },
  functions: {
    transfer: function transfer(asset) {
      return asset.transfer;
    },
    assetsOfOwnerByIndex: []
  },
  events: {
    transfer: []
  },
  hash: function hash(a) {
    return JSON.stringify(a);
  }
};